import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

export interface VoxelPanelProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  paddingClass?: string;
  shadowClass?: string;
  className?: string;
  bgClass?: string;
  borderClass?: string;
}

export const VoxelPanel = React.forwardRef<HTMLDivElement, VoxelPanelProps>(
  (
    {
      children,
      paddingClass = 'p-0',
      shadowClass = 'shadow-sm',
      className,
      bgClass = 'bg-white',
      borderClass = 'border-none',
      ...divProps
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={`
        ${bgClass}
        rounded-lg
        ${className}
        ${shadowClass}
        ${borderClass}
        ${paddingClass}
        overflow-y-visible
      `}
        {...divProps}
      >
        {children}
      </div>
    );
  }
);

export default VoxelPanel;
